import React, { useState } from 'react'
import HCTSetnewpasswdForm from '../HCT components/SetNewPassword/HCTSetnewpasswdForm'
import { useNavigate } from 'react-router-dom'

const HCTSetNewpasswordPage = () => {

    return (
        <div>
            <HCTSetnewpasswdForm />
        </div>
    )
}

export default HCTSetNewpasswordPage
